import { Tool } from "@/types/tools";
import { ApartmentOutlined } from "@ant-design/icons";
import { useRouter } from "next/router";
import { useEffect } from "react";
const buildSidebarRedirect = () => "/archetypes";
const Render = () => {
  const router = useRouter();
  useEffect(() => {
    router.replace(buildSidebarRedirect());
  }, []);
  return <></>;
};
export default {
  id: "archetypes",
  category: "reference",
  keyPrefix: "reference.archetypes",
  icon: <ApartmentOutlined />,
  render: () => <Render />,
  buildSidebarRedirect
} as Tool;